import { getConfig } from '@local/app-config';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { createApi } from '@reduxjs/toolkit/query/react';

import {
    GLOBAL_DISCOVERY_DEVELOPMENT_URL,
    GLOBAL_DISCOVERY_INTEGRATION_URL,
} from '../../constants';
import { clearCombinedToken as clearAccessToken } from '../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import { processResult } from '../identityClient/requests/BentleyAccessTokenApi';

// This Discovery API client handles requests to the discovery service for Central.

// Indicates whether to force the OAuth prefix in requests (This is no longer needed for central-portal slots, so it is set to false).
const forceOauthPrefix = false;

// In only Dev and Integration we need to call both Discovery endpoints at the same time to return instances from each environment in Central.
function resolveDiscoveryEndpoints(baseUrl: string) {
    if (
        baseUrl === GLOBAL_DISCOVERY_DEVELOPMENT_URL ||
        baseUrl === GLOBAL_DISCOVERY_INTEGRATION_URL
    ) {
        return {
            primaryUrl: GLOBAL_DISCOVERY_DEVELOPMENT_URL,
            secondaryUrl: GLOBAL_DISCOVERY_INTEGRATION_URL,
        };
    }

    return {
        primaryUrl: baseUrl,
        secondaryUrl: undefined,
    };
}

// We fetch the config at run time so it is loaded before the first request.
// Tests can override it as well.
const discoveryBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
    args,
    WebApi,
    extraOptions,
) => {
    const { primaryUrl, secondaryUrl } = resolveDiscoveryEndpoints(getConfig().discovery_url);

    const result = await processResult(
        args,
        WebApi,
        extraOptions,
        forceOauthPrefix,
        primaryUrl,
        secondaryUrl,
    );
    if (result.error?.status === 401) {
        clearAccessToken();
    }
    return result;
};

export const DiscoveryApiClient = createApi({
    reducerPath: 'discoveryAPI',
    baseQuery: discoveryBaseQuery,
    endpoints: () => ({}),
});
